<template>
  <f7-page class="my-coin-page page">
    <template v-if="backKey===true">
      <f7-navbar >
        <f7-nav-left style="padding-left:15px;">
           <i class="icon icon-back" @click="backIndex()" ></i>
        </f7-nav-left>
      </f7-navbar>
    </template>
    <template v-else>
      <f7-navbar   >
        <div style="width:100%;text-align:center;">
                 　
        </div>
      </f7-navbar>
    </template>
 
    <header class="wave-header sticky-top">
      <div class="coin-total">
      <!--
        <p>114年度第2學期2月份培育點數</p>
        <h1>{{ currentAmount }} 點</h1> -->

        <p>勵學金資訊</p>
      </div>
    </header>
 
<!--
    <header class="wave-header sticky-top">
      <div class="coin-total">
        <p>110年度第2學期7月份培育點數</p>
        <h1>更新中.</h1>
      </div>
    </header>
 


 
    <div class="list media-list">
      <ul>
        <li>
          <a   class="item-content">
            <div class="item-media">
              <img src="../../images/icon/my-coin/strenth.png" width="44" />
            </div>
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">領袖培育</div>
                
                <div class="item-after dollar">更新中</div>
                
              </div>
              <div style="display:none" class="item-text">{{softUpdated}} 更新</div>
            </div>
          </a>
        </li>
        <li>
          <a class="item-content">
            <div class="item-media">
              <img src="../../images/icon/my-coin/welfare.png" width="44" />
            </div>
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">服務實踐</div>
                
                <div class="item-after dollar">更新中9</div>
                
              </div>
              <div style="display:none" class="item-text">{{serviceUpdated}} 更新</div>
            </div>
          </a>
        </li>
        <li>
          <a href class="item-content">
            <div class="item-media">
              <img src="../../images/icon/my-coin/career.png" width="44" />
            </div>
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">職涯輔導</div>
                
                <div class="item-after dollar">更新中</div>
               
              </div>
              <div  style="display:none" class="item-text">{{jobUpdated}} 更新</div>
            </div>
          </a>
        </li>
        <li>
          <a  class="item-content">
            <div class="item-media">
              <img src="../../images/icon/my-coin/study.png" width="44" />
            </div>
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">課業輔導</div>
              
                <div class="item-after dollar">更新中</div>
                
              </div>
              <div style="display:none" class="item-text">{{mergeUpdated}} 更新</div>
            </div>
          </a>
        </li>
        <li>
          <a  class="item-content">
            <div class="item-media">
              <img src="../../images/icon/my-coin/fieldwork.png" width="44" />
            </div>
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">學習型實習</div>              
                <div class="item-after dollar">更新中</div>
                
              </div>
              <div style="display:none" class="item-text">{{leaningUpdated }} 更新</div>
            </div>
          </a>
        </li>
        


      </ul>
     
    </div> 
 
-->
  
 
    <div class="list media-list">
      <ul>
        <li>

          <a   href="/coin-detail10" class="item-content">
            <div class="item-media">
              <img src="../../images/icon/my-coin/strenth.png" width="44" />
            </div>
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">領袖培育</div>
<!--
                   <div class="item-after dollar">{{softAmmount}} 點</div> -->
              </div>
              
              <div style="display:none" class="item-text">{{softUpdated}} 結算</div>
            
              <div style="display:none" class="item-text">結算中</div>
            </div>
          </a>
        </li>
        <li>
          <a href="/coin-detail30" class="item-content">
            <div class="item-media">
              <img src="../../images/icon/my-coin/welfare.png" width="44" />
            </div>
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">服務實踐</div>
                <!--
                <div class="item-after dollar">{{serviceAmmount}} 點</div>-->
                
              </div>
              <div style="display:none" class="item-text">{{serviceUpdated}} 結算</div>
            </div>
          </a>
        </li>
        <li>
          <a href="/coin-detail20" class="item-content">
            <div class="item-media">
              <img src="../../images/icon/my-coin/career.png" width="44" />
            </div>
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">職涯輔導</div>
                <!--
                <div class="item-after dollar">{{jobAmmount}} 點</div>-->
               
              </div>
              <div  style="display:none" class="item-text">{{jobUpdated}} 結算</div>
            </div>
          </a>
        </li>
        <li>
          <a href="/coin-detail50" class="item-content">
            <div class="item-media">
              <img src="../../images/icon/my-coin/study.png" width="44" />
            </div>
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">課業輔導</div>
              <!--
                <div class="item-after dollar">{{ mergeAmount }} 點</div>-->
                
              </div>
              <div style="display:none" class="item-text">{{mergeUpdated}} 結算</div>
            </div>
          </a>
        </li>
        <li>
          <a href="/coin-detail40" class="item-content">
            <div class="item-media">
              <img src="../../images/icon/my-coin/fieldwork.png" width="44" />
            </div>
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">學習型實習</div>              

                <!--
                <div class="item-after dollar">{{learningAmmount}} 點</div>-->
                
              </div>
              <div style="display:none" class="item-text">{{leaningUpdated }} 結算</div>
            </div>
          </a>
        </li>
        


      </ul>
     
    </div>  
  

  </f7-page>
</template>

<script>
import Service from "../../service";
import axios from '../../js/axiosModule';
export default {
  components: {},
  data() {
    return {
      currentAmount:0,
      mergeAmount:0,
      mergeUpdated:'',
      jobAmmount:0,
      jobUpdated:'',
      softAmmount:0,
      softUpdated:'',
      serviceAmmount:0,
      serviceUpdated:'',
      learningAmmount:0,
      leaningUpdated:'',
      dish: Service.getDish(this.$f7route.params.id),
      backKey:this.$f7route.query.back === undefined ? true : false
    };
  },methods: {
    getCoinAmount:function() {
      let self= this;
      
      axios.axiosTokenGet(self.$app.axiosUrl+'/api/CoinSummary/GetCoinSummaries/'+self.$store.state.userInfo.studentNo).then((response)=> {
        
        for (var i = 0 ; i < response.data.data.length ; i++ ) {
          self.currentAmount += response.data.data[i].currentAmount;          
          if (response.data.data[i].summaryType === 50) {
            self.mergeAmount += response.data.data[i].currentAmount;
            self.mergeUpdated = response.data.data[i].updatedAt.split("T")[0];
          } else if (response.data.data[i].summaryType === 20) {
            self.jobAmmount += response.data.data[i].currentAmount;
            self.jobUpdated = response.data.data[i].updatedAt.split("T")[0];
          } else if (response.data.data[i].summaryType === 10) {
            self.softAmmount += response.data.data[i].currentAmount;
            self.softUpdated = response.data.data[i].updatedAt.split("T")[0];
          } else if (response.data.data[i].summaryType === 30) {            
            self.serviceAmmount += response.data.data[i].currentAmount;
            self.serviceUpdated = response.data.data[i].updatedAt.split("T")[0];
          } else if (response.data.data[i].summaryType === 40) {
            self.learningAmmount += response.data.data[i].currentAmount;
            self.leaningUpdated = response.data.data[i].updatedAt.split("T")[0];
          }
        }
       self.currentAmount = self.formatNumber(self.currentAmount);
      
       self.mergeAmount = self.formatNumber(self.mergeAmount);
       self.jobAmmount = self.formatNumber(self.jobAmmount);
       self.softAmmount = self.formatNumber(self.softAmmount);
       self.serviceAmmount = self.formatNumber(self.serviceAmmount);
       self.learningAmmount = self.formatNumber(self.learningAmmount);
      }).catch(err=>function() {
        if ( self.$store.state.userInfo === undefined || self.$store.state.userInfo === null ) {
           self.$f7router.navigate("/login");
        } 
      });
    },
    formatNumber : function(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    },
    backIndex:function() {
      this.$f7router.navigate("/" );
    },
  },mounted() {
    let self = this;
    self.getCoinAmount();
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/my-coin/coin-item.vue